// removed by extract-text-webpack-plugin
module.exports = {"table":"foCdruYcYKYWOOLemDfli","details":"_3XbWnZfKmSbPEgCXhEXgws","active":"_122rh57v_oJS45od_qWDa6","important":"_1RSxDtoOa_-xrPwAW4bAv0","clickableDataRow":"_2G_FZOZ32KeDulK2Jd-mTH","sortArrowAsc":"_3Gdyg1BK9PFj7IUObbsf_G","sortArrowDesc":"_36GdUuvd4z9sDT-2nqQwtk"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/DataTable/DataTable.scss
// module id = ./node_modules/wix-style-react/dist/es/src/DataTable/DataTable.scss
// module chunks = 0